import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { cc } from "../../../../lib/utils.js";
const cascaderComboboxVariants = tv({
  base: `
    inline-flex items-center border truncate rounded-md cursor-pointer outline-none transition-[background-color,border-color,color,box-shadow]
    ${cc(
    /* 定义禁用时的状态 */
  )}
    aria-[disabled=true]:bg-(--gray-tag-1-alpha) aria-[disabled=true]:pointer-events-none aria-[disabled=true]:cursor-not-allowed
    ${cc(
    /* 定义focus时的颜色 */
  )}
    focus:border-(--border-3-alpha) focus:ring-(--border-1-alpha) focus:ring-[1px]
    ${cc(
    /* 定义错误时的颜色 */
  )}
    aria-invalid:border-(--red-6-alpha) aria-invalid:focus:ring-(--red-3-alpha)
  `,
  variants: {
    hasValue: {
      true: "text-(--gray-text-2)",
      false: "text-(--gray-primary-1-alpha)"
      // 没有值时的placeholder的颜色
    },
    size: {
      sm: "px-1 h-6 gap-1 text-sm",
      default: "px-2 h-9 gap-2 text-base",
      lg: "px-2 h-10 gap-2 text-lg"
    },
    variants: {
      default: "bg-(--white) border-(--gray-tag-3-alpha)",
      filled: "bg-(--tag-1-alpha) border-transparent"
    }
  },
  defaultVariants: {
    hasValue: !1,
    size: "default",
    variants: "default"
  }
}), cascaderPanelItemVariants = tv({
  base: "flex cursor-pointer items-center justify-between px-3 py-2 text-sm",
  variants: {
    disabled: {
      true: "cursor-not-allowed opacity-60",
      false: void 0
    },
    selected: {
      true: "bg-(--primary-1) text-(--white) dark:text-(--gray-text-2)",
      false: void 0
    }
  },
  compoundVariants: [
    { disabled: !1, selected: !1, class: "hover:bg-(--gray-bg-2) hover:text-(--gray-text-2)" }
  ],
  defaultVariants: {
    disabled: !1,
    selected: !1,
    active: !1
  }
});
export {
  cascaderComboboxVariants,
  cascaderPanelItemVariants
};
//# sourceMappingURL=index.js.map
